var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"50px"}},[_c('el-descriptions',{attrs:{"title":"系統信息","direction":"horizontal","column":1}},[_c('el-descriptions-item',{attrs:{"label":"系統名稱"}},[_vm._v("S'IM")]),_c('el-descriptions-item',{attrs:{"label":"系統版本"}},[_vm._v(_vm._s(this.version))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }